/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMeetingTemplateAgendaItemDto } from '../models/work-create-meeting-template-agenda-item-dto';
import { WorkMeetingTemplateAgendaItem } from '../models/work-meeting-template-agenda-item';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMeetingTemplateAgendaItemDto } from '../models/work-update-meeting-template-agenda-item-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingTemplateAgendaItemsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingTemplateAgendaItemsV2ControllerFindAllPaginated()` */
  static readonly MeetingTemplateAgendaItemsV2ControllerFindAllPaginatedPath = '/v2/meeting-template-agenda-items';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateAgendaItemsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateAgendaItemsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingTypeId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingTypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingTypeId=$not:$like:John Doe&filter.meetingTypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingTypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>sortableRank</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateAgendaItemsV2Service.MeetingTemplateAgendaItemsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.meetingTypeId', params['filter.meetingTypeId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeetingTemplateAgendaItem>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'meetingTypeId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateAgendaItemsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateAgendaItemsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingTypeId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingTypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingTypeId=$not:$like:John Doe&filter.meetingTypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingTypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>sortableRank</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
}> {
    return this.meetingTemplateAgendaItemsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingTemplateAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingTypeId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingTemplateAgendaItemsV2ControllerCreate()` */
  static readonly MeetingTemplateAgendaItemsV2ControllerCreatePath = '/v2/meeting-template-agenda-items';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateAgendaItemsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateAgendaItemsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingTemplateAgendaItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateAgendaItemsV2Service.MeetingTemplateAgendaItemsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateAgendaItemsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateAgendaItemsV2ControllerCreate(
    params: {
      body: WorkCreateMeetingTemplateAgendaItemDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateAgendaItem> {
    return this.meetingTemplateAgendaItemsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateAgendaItem>): WorkMeetingTemplateAgendaItem => r.body)
    );
  }

  /** Path part for operation `meetingTemplateAgendaItemsV2ControllerFindOneById()` */
  static readonly MeetingTemplateAgendaItemsV2ControllerFindOneByIdPath = '/v2/meeting-template-agenda-items/{id}';

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateAgendaItemsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateAgendaItemsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateAgendaItemsV2Service.MeetingTemplateAgendaItemsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:read, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateAgendaItemsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateAgendaItemsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateAgendaItem> {
    return this.meetingTemplateAgendaItemsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateAgendaItem>): WorkMeetingTemplateAgendaItem => r.body)
    );
  }

  /** Path part for operation `meetingTemplateAgendaItemsV2ControllerDelete()` */
  static readonly MeetingTemplateAgendaItemsV2ControllerDeletePath = '/v2/meeting-template-agenda-items/{id}';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateAgendaItemsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateAgendaItemsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateAgendaItemsV2Service.MeetingTemplateAgendaItemsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateAgendaItemsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingTemplateAgendaItemsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateAgendaItem> {
    return this.meetingTemplateAgendaItemsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateAgendaItem>): WorkMeetingTemplateAgendaItem => r.body)
    );
  }

  /** Path part for operation `meetingTemplateAgendaItemsV2ControllerUpdate()` */
  static readonly MeetingTemplateAgendaItemsV2ControllerUpdatePath = '/v2/meeting-template-agenda-items/{id}';

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingTemplateAgendaItemsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateAgendaItemsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingTemplateAgendaItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingTemplateAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingTemplateAgendaItemsV2Service.MeetingTemplateAgendaItemsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingTemplateAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-types:update, meeting-types:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingTemplateAgendaItemsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingTemplateAgendaItemsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingTemplateAgendaItemDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingTemplateAgendaItem> {
    return this.meetingTemplateAgendaItemsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingTemplateAgendaItem>): WorkMeetingTemplateAgendaItem => r.body)
    );
  }

}
